import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1655283494318'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='6192'
    >
        <path
            d='M876 680c46.392 0 84 37.608 84 84s-37.608 84-84 84H428c-46.392 0-84-37.608-84-84s37.608-84 84-84h448z m-728 0c46.392 0 84 37.608 84 84s-37.608 84-84 84-84-37.608-84-84 37.608-84 84-84z m728-280c46.392 0 84 37.608 84 84s-37.608 84-84 84H428c-46.392 0-84-37.608-84-84s37.608-84 84-84h448z m-728 0c46.392 0 84 37.608 84 84s-37.608 84-84 84-84-37.608-84-84 37.608-84 84-84zM876 120c46.392 0 84 37.608 84 84s-37.608 84-84 84H428c-46.392 0-84-37.608-84-84s37.608-84 84-84h448zM148 120c46.392 0 84 37.608 84 84s-37.608 84-84 84-84-37.608-84-84 37.608-84 84-84z'
            p-id='6193'
            fill='currentColor'
        ></path>
    </svg>
)

export const ProLogSettingIcon = props => <Icon component={SVG} {...props} />
